import {
  Flex,
  Box,
  Text,
  Divider,
  Tooltip,
  Switch,
} from '@mantine/core'

import {  useTranslation } from '@flecto/translations'
import { type UNSAFE_any } from '@flecto/types'

import { useFormContext } from './FormBundle'

const SwitchWithTooltip = ({
  tooltipTitle,
  name,
  disabled,
  checked,
  onChange,
  toolTipDisabled = false,
}: {
  tooltipTitle: string | undefined
  name: string
  disabled: boolean
  checked: boolean
  onChange: (value: UNSAFE_any) => void
  toolTipDisabled?: boolean
}) => (
  <Tooltip
    label={tooltipTitle}
    disabled={toolTipDisabled}
    data-testid={`tooltip-${name}`}
  >
    <Box>
      <Switch
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        data-testid={`switch-${name}`}
      />
    </Box>
  </Tooltip>
)

export function TabSettings() {
  const form = useFormContext()
  const { t } = useTranslation('saas', { keyPrefix: 'items' })

  return (
    <Box>
      <Box>
        <Text fw={500}>{t('new_bundle_settings_title')}</Text>
        <Text c='dimmed'>{t('new_bundle_settings_description')}</Text>
      </Box>
      <Divider bg='gray.5' my='lg' />
      <Flex
        align='center'
        justify='space-between'
        mb='md'
        data-testid='active-row'
      >
        <Flex direction='column'>
          <Text fw='500'>{t('new_bundle_settings_active_title')}</Text>
          <Text c='dimmed'>{t('new_bundle_settings_active_description')}</Text>
        </Flex>
        <Switch
          data-testid='switch-status'
          onChange={(e) => {
            form.setFieldValue(
              'status',
              e.currentTarget.checked ? 'enabled' : 'disabled'
            )
          }}
          checked={form.values.status === 'enabled'}
        />
      </Flex>
      <Flex align='center' justify='space-between' data-testid='store-row'>
        <Flex direction='column'>
          <Text fw='500'>{t('new_bundle_settings_store_title')}</Text>
          <Text c='dimmed'>{t('new_bundle_settings_store_description')}</Text>
        </Flex>
        <Switch
          data-testid='switch-on_store'
          onChange={(e) => {
            form.setFieldValue('on_store', e.currentTarget.checked)
          }}
          checked={form.values.on_store}
        />
      </Flex>
    </Box>
  )
}
